import { Attrs, EventListeners, MinzeElement, Reactive } from 'minze'
import { LvcPrimarySliderItem } from '../../modules/sliderUtils'
import { mapEvent } from '../../modules/utils'
import { LvcItemSourceData } from '../../../types/global'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'lvcEventShowMore', {
  seeMore: "{{eventCount}} autres aujourd'hui",
})
Locale.getInstance().registerKeySet('en', 'lvcEventShowMore', {
  seeMore: '{{eventCount}} others today',
})

export interface LvcEventShowMore {
  items: string
  parsedItems: LvcItemSourceData[]
  formattedItems: LvcPrimarySliderItem[]
}

export class LvcEventShowMore extends MinzeElement {
  attrs: Attrs = ['items']
  reactive: Reactive = [
    ['isOpen', false],
    ['isHovered', false],
  ]
  onReady = () => {
    this.parsedItems = JSON.parse(decodeURIComponent(this.items))
    this.formattedItems = this.parsedItems.map(item => mapEvent(item) as LvcPrimarySliderItem)
    this.rerender()
  }
  renderItem = (item: LvcPrimarySliderItem) => {
    return `
      <a class="lvc-event-show-more__link" href=${item?.urlConstruct?.[Locale.language]}>
        <lvc-event-date text="${item?.startTime}"></lvc-event-date>
        <lvc-event-location text="${item?.location?.[Locale.language]}"></lvc-event-location>
      </a>
    `
  }
  handleLinkClick = (e: Event) => {
    const target = e.target as HTMLElement
    if (!target) return
    const link = target.closest('.lvc-event-show-more__link') as HTMLAnchorElement
    if (!link) return
    window.location.href = link.href
  }
  html = () => `
    <div class="lvc-event-show-more__wrapper">
      <div class="lvc-event-show-more__button">
        ${this.isOpen ? minusIcon : plusIcon}
      </div>
      <div>
        ${Locale.getKey('lvcEventShowMore.seeMore', {
          eventCount: this.formattedItems ? this.formattedItems.length : 0,
        })}
      </div>
    </div>
    <div class="lvc-event-show-more__list-wrapper">
        ${
          this.formattedItems
            ? this.formattedItems
                .map(
                  item => `
          ${this.renderItem(item)}
        `
                )
                .join('')
            : ''
        }
      </div>
  `
  css = () => `
    :host {
      font-size: 12px;
    }
    .lvc-event-show-more__wrapper {
      display: flex;
      align-items: center;
      gap: 6px;

    }
    .lvc-event-show-more__button {
      height: 24px;
      width: 24px;
      display:flex;
      justify-content: center;
      align-items: center;
      border-radius: 100%;
      background-color: white;
    }
    .lvc-event-show-more__list-wrapper {
      font-size: 14px;
      margin-top: 8px;
      display: ${this.isOpen ? 'flex' : 'none'};
      gap: 8px;
    }
    .lvc-event-show-more__link {
      font-size: 14px;
      display: flex;
      flex-direction: column;
      align-items: start;
      text-decoration: none;
      color: #1E007D;
      padding: 4px 8px;
      border-radius: 18px;
      border: ${this.isHovered ? '1px solid #1E007D' : '1px solid transparent'};
      background-color: rgb(255,255,255);
      transition: all 0.2s ease;
    }
    .lvc-event-show-more__link:hover {
      border: 1px solid rgba(30, 0, 125, 0.30);
      box-shadow: 0 0 4px rgba(0,0,0,0.1);
    }
  `
  eventListeners: EventListeners = [
    ['.lvc-event-show-more__button', 'click', () => (this.isOpen = !this.isOpen)],
    ['.lvc-event-show-more__link', 'click', e => this.handleLinkClick(e)],
  ]
}

const plusIcon = `
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M6.69556 1.52148C6.92001 4.82746 7.23425 11.6471 6.69556 12.478" stroke="#1E007D" stroke-width="1.21739" stroke-linecap="round"/>
<path d="M12.1738 6.99975C8.87508 6.93242 2.34829 6.83817 1.2173 6.99975" stroke="#1E007D" stroke-width="1.21739" stroke-linecap="round"/>
</svg>

`
const minusIcon = `
<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.1738 6.99975C8.87508 6.93242 2.34829 6.83817 1.2173 6.99975" stroke="#1E007D" stroke-width="1.21739" stroke-linecap="round"/>
</svg>

`
